const strings = {
  every: 'jeden',
  until: 'bis',
  day: 'Tag',
  days: 'Tage',
  week: 'Woche',
  weeks: 'Wochen',
  on: 'am',
  in: 'in',
  'on the': 'am',
  for: 'für',
  and: 'und',
  or: 'oder',
  at: 'bei',
  last: 'zuletzt',
  st: '.',
  nd: '.',
  rd: '.',
  th: '.',
  '(~ approximate)': '(~ ungefähr)',
  times: 'Termine',
  time: 'Termin',
  minutes: 'Minuten',
  hours: 'Stunden',
  weekdays: 'Wochentage',
  weekday: 'Wochentag',
  months: 'Monate',
  month: 'Monat',
  years: 'Jahre',
  year: 'Jahr',
  allDay: 'ganztags',
  from: 'ab',
};

const dayNames = [
  'So',
  'Mo',
  'Di',
  'Mi',
  'Do',
  'Fr',
  'Sa',
];

const monthNames = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
];

/**
 * @param {string} monthString
 *
 * @return string
 */
function monthStringToNumber(monthString) {
  return String(monthNames.indexOf(monthString) + 1).padStart(2, '0');
}

const translationFixes = {
  'jeden Wochen': 'jede Woche',
  'jeden Woche am ': '',
  'jeden Tag': 'Täglich',
  'jeden Monat': 'Monatlich',
  'jede Wochetag': dayNames.slice(1, 6).join(', '),
};

export default {
  getText: id => strings[id] || id,
  language: {
    dayNames,
    monthNames,
  },
  dateFormat: (year, month, day) => `${String(day).padStart(2, '0')}.${monthStringToNumber(month)}.${year}`,
  fixTranslationErrors: (translatedString) => {
    Object.keys(translationFixes).forEach((key) => {
      translatedString = translatedString.replace(key, translationFixes[key]);
    });

    return translatedString;
  },
};
